import { Link } from "react-router-dom";
import { useRef } from "react";
import { toast } from "sonner";
import { popConfetti } from "@/lib/confetti";

const MESSAGES = [
  null,
  null,
  "You've found a secret! Keep tapping...",
  "Almost there...",
  "🎉 You're a true SECQRE fan!",
];

export default function Logo({ size = "md", inverted = false, className = "" }) {
  const sizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-4xl md:text-5xl",
    xl: "text-6xl md:text-7xl",
  };
  const color = inverted ? "text-white" : "text-[#0A0A0A]";
  const countRef = useRef(0);
  const lastTapRef = useRef(0);

  const onClick = (e) => {
    const now = Date.now();
    // reset counter if more than 1.5s between taps
    if (now - lastTapRef.current > 1500) countRef.current = 0;
    lastTapRef.current = now;
    countRef.current += 1;
    const c = countRef.current;
    const msg = MESSAGES[c - 1];
    if (msg) {
      if (c === 5) {
        e.preventDefault();
        const r = e.currentTarget.getBoundingClientRect();
        popConfetti({ x: (r.left + r.width / 2) / window.innerWidth, y: (r.top + r.height / 2) / window.innerHeight });
        toast.success(msg, { description: "Try typing 'secqre' anywhere on the site." });
        countRef.current = 0;
      } else {
        toast(msg);
      }
    }
  };

  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="site-logo"
      className={`inline-flex items-baseline font-heading font-black tracking-tight ${sizes[size]} ${color} ${className} select-none`}
      aria-label="SECQRE home"
    >
      <span>SEC</span>
      <span className="relative inline-block">
        Q
        <span aria-hidden className="absolute left-0 right-0 bottom-[12%] h-[34%] -z-10 bg-[#FFD600]" />
      </span>
      <span>RE</span>
    </Link>
  );
}
